/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const estimationSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  estimationSchemeId: z.int(),
  highEffort: z.int().nullish(),
  id: z.int(),
  label: z.string(),
  lowEffort: z.int().nullish(),
  organizationId: z.string(),
  priority: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
